import { BrandLogo } from "@/components/BrandLogo";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200 py-10 px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <BrandLogo className="h-7" />
        </div>
        <p className="text-xs text-slate-500 text-center">
          © {new Date().getFullYear()} CareerStudy360 &nbsp;·&nbsp; careerstudy360.com &nbsp;·&nbsp; Developed by Geneza Solutions Private Limited
        </p>
      </div>
    </footer>
  );
}
